import React, { useState, useEffect } from 'react';

import getNLS from '../common/_NLS';

export default props=>{
    var defaultCF = props.communityFilter;
    if (defaultCF == null) defaultCF = { gender: "전체", season: "전체", color: "전체" };

    const [vGender, setGender] = useState(defaultCF.gender);
    const [vSeason, setSeason] = useState(defaultCF.season);
    const [vColor , setColor ] = useState(defaultCF.color );

    useEffect(()=>{
        setGender(defaultCF.gender);
        setSeason(defaultCF.season);
        setColor (defaultCF.color );
    }, [defaultCF.gender, defaultCF.season, defaultCF.color ]);


    const jsx = (<div className="this-content">
        <style jsx>{`

.this-content{
    width: 500px;
    padding: 32px 24px 48px;
    background-color: #fefefe;
}

.header{}

.title{
    font-size: 24px;
    font-weight: bold;
    color: #343a40;

}

.title2{
    font-size: 14px;
    margin: 0 0 0 16px;
    color: #343a40;
}

.section{
    padding: 10px 0;

    font-size: 14px;
    font-weight: bold;
    line-height: 1.71;
    letter-spacing: -0.25px;
    color: #343a40;

}

.tail{}


.toggle{
width: 80px;
height: 40px;
margin: 0 5px;
border-radius: 20px;
border: solid 1px #ced4da;

font-size: 14px;
text-align: center;
padding-top: 8px;

color: #495057;
}

.toggle.highlighted{
    background-color: #55d5ce;
    color: white;
}


.colorchip {
    width: 32px;
    height: 32px;
    border: solid 1px #dee2e6;
    border-radius: 32px;

    margin: 8px 4px;

    text-align: center;
    color: white;
}

.lcg-check{
    width: 18px;
    vertical-align: middle;
    padding: 1px 0 0 1px;
}


.tail{
    margin: auto;
    width: 180px;
}
.whitebutton2 {
    width: 80px;
    height: 40px;
    line-height: 40px;

    font-size: 14px;
    text-align: center;

    border: solid 1px #adb5bd;
}


@media all and (max-width:606px) {
    .this-content{
        width: auto;
        position: fixed;
        top: 0;
        bottom: 0;
        /* left: 0; */
        /* right: 0; */
        padding: 32px 16px;
        overflow: auto;
    }

    .x2{
        float: right;
        margin: 0;
    }

    .header{
        text-align: center;
    }

    .title{
        display:block;
    }

    .title2{
        display:block;
        padding-top: 16px;
    }

    .toggle{
        margin: 4px;
        width: 30%;
    }

    .tail{width: 100%;}

    .whitebutton2{
        width: 100%;
        margin: 4px 0;
    }

    .blackbutton{
        width: 100%;
        margin: 4px 0;
    }

}

`}</style>

        <img className="x2 dibom" onClick={props.hide} src="/assets/images-m/x_2.svg" />
        <div className="header">
            <div className="dib title">{getNLS("필터")}</div>
            <div className="dib title2">{getNLS("원하시는 조건을 선택해서 적용해주세요.")}</div>
        </div>

        <div className="">&nbsp;</div>
        <div className="section">{getNLS("성별")}</div>
        <a onClick={()=>{setGender("전체")}}><div className={`dib toggle ${(vGender=="전체"?"highlighted":"")}`}>{getNLS("전체")}</div></a>
        <a onClick={()=>{setGender("남자")}}><div className={`dib toggle ${(vGender=="남자"?"highlighted":"")}`}>{getNLS("남자")}</div></a>
        <a onClick={()=>{setGender("여자")}}><div className={`dib toggle ${(vGender=="여자"?"highlighted":"")}`}>{getNLS("여자")}</div></a>
        <a onClick={()=>{setGender("같이")}}><div className={`dib toggle ${(vGender=="같이"?"highlighted":"")}`}>{getNLS("같이")}</div></a>
        <a onClick={()=>{setGender("기타")}}><div className={`dib toggle ${(vGender=="기타"?"highlighted":"")}`}>{getNLS("기타")}</div></a>
        <div className="">&nbsp;</div>
        <div className="section">시즌</div>
        <a onClick={() => { setSeason("전체") }}><div className={`dib toggle ${(vSeason == "전체" ? "highlighted" : "")}`}>{getNLS("전체")}</div></a>
        <a onClick={() => { setSeason("봄"  ) }}><div className={`dib toggle ${(vSeason == "봄"   ? "highlighted" : "")}`}>{getNLS("봄")}  </div></a>
        <a onClick={() => { setSeason("여름") }}><div className={`dib toggle ${(vSeason == "여름" ? "highlighted" : "")}`}>{getNLS("여름")}</div></a>
        <a onClick={() => { setSeason("가을") }}><div className={`dib toggle ${(vSeason == "가을" ? "highlighted" : "")}`}>{getNLS("가을")}</div></a>
        <a onClick={() => { setSeason("겨울") }}><div className={`dib toggle ${(vSeason == "겨울" ? "highlighted" : "")}`}>{getNLS("겨울")}</div></a>
        <div className="">&nbsp;</div>
        <div className="section">{getNLS("컬러")}</div>
        {
            ["#f23627", "#e92163", "#9b26af", "#3e4fb4", "#00a8f3", "#00bbd3", "#40dab8", "#4caf50", "#cedc39", "#feec3b", "#f85c00", "#795447", "#f7f3d8", "#9d9d9d", "#ffffff", "#000000"]
            .map((v,i)=>{
                return (<a key={i} onClick={() => { setColor(v) }}>
                    <div className="dib colorchip" style={{ backgroundColor: v }}>
                        {(v == vColor ? 
                            <img className="lcg-check" src="/assets/images3/lcg-check.png" /> 
                        : <>&nbsp;</>)}
                    </div>
                </a>);
            })
        }

        <div className="">&nbsp;</div>
        <div className="">&nbsp;</div>
        <div className="tail">
            <a onClick={() => {
                setGender(defaultCF.gender);
                setSeason(defaultCF.season);
                setColor (defaultCF.color );
            }}><div className="dib whitebutton2">{getNLS("원래대로")}</div></a>
            <a onClick={() => {
                props.save && props.save({ 'gender': vGender, 'season': vSeason, 'color': vColor });
            }} ><div className="dib blackbutton">{getNLS("적용")}</div></a>
        </div>



    </div>);
    return(jsx);
}

